<template>
  <div>
    <v-card class="ma-3" elevation="2">
      <v-card-title>
        <v-icon left color="primary">mdi-history</v-icon>
        History
      </v-card-title>
      <PageExplanation page-key="History" />
    </v-card>
    <v-text-field
      v-model="search"
      append-icon="search"
      label="Search by ID"
      single-line
      solo
      class="ma-3 pa-3"
      hide-details
    ></v-text-field>
    <VueAutoVirtualScrollList
      :totalHeight="pageHeight"
      :defaultHeight="250"
      style="width: 100%;"
      ref="scroll"
    >
      <v-card
        elevation="2"
        v-for="(item, index) in searchHistory(search)"
        :key="index"
        class="ma-3 pa-0"
        outlined
      >
        <v-card-title class="pb-2">
          <v-chip small color="primary" text-color="white" class="mr-2">
            {{ item.tablename }}
          </v-chip>
          <v-chip small outlined class="mr-2">
            <v-icon small left>mdi-table-column</v-icon>
            {{ item.columnname }}
          </v-chip>
          <v-spacer />
          <v-chip small color="grey lighten-2">
            ID: {{ item.changedId }}
          </v-chip>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pb-2 pt-3">
          <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-md-2">
              <div class="text-caption grey--text text--darken-1 mb-1">
                <v-icon x-small color="red darken-1" class="mr-1"
                  >mdi-minus-circle</v-icon
                >
                Previous Value
              </div>
              <v-sheet
                v-if="!item.changedFrom"
                color="grey lighten-4"
                class="pa-3 rounded text-center"
              >
                <span class="grey--text text--darken-1 font-italic">Empty</span>
              </v-sheet>
              <v-sheet v-else color="red lighten-5" class="pa-3 rounded">
                <span class="text-body-2">{{ item.changedFrom }}</span>
              </v-sheet>
            </v-col>

            <v-col cols="12" md="6" class="pl-md-2 mt-3 mt-md-0">
              <div class="text-caption grey--text text--darken-1 mb-1">
                <v-icon x-small color="green darken-1" class="mr-1"
                  >mdi-plus-circle</v-icon
                >
                New Value
              </div>
              <v-sheet color="green lighten-5" class="pa-3 rounded">
                <span class="text-body-2 font-weight-medium">{{
                  item.changedTo
                }}</span>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-4 py-2 grey lighten-4">
          <v-chip x-small outlined>
            <v-icon x-small left>mdi-account</v-icon>
            {{ item.username }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-chip x-small outlined>
            <v-icon x-small left>mdi-clock-outline</v-icon>
            {{ item.Date }}
          </v-chip>
        </v-card-actions>
      </v-card>
    </VueAutoVirtualScrollList>
    <v-btn
      @click="$refs.scroll.setIndex(0)"
      color="purple darken-1"
      dark
      fixed
      bottom
      right
      fab
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from "vue";
import { formatInTimeZone } from "date-fns-tz";
import { currentTimeZone } from "@/helpers";
import { getHistory } from "../../api";
import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";

export default Vue.extend({
  async created() {
    let history = await getHistory();
    this.list = history.map(item => ({
      ...item,
      Date: formatInTimeZone(
        new Date(item.Date.slice(0, -5)),
        currentTimeZone(),
        "yyyy-MM-dd HH:mm:ss"
      )
    }));
  },
  components: { VueAutoVirtualScrollList },
  data: () => {
    return {
      list: [],
      search: "",
      filtered: [],
      scroll: 0
    };
  },
  computed: {
    pageHeight() {
      return (
        Math.min(
          document.body.scrollHeight,
          document.documentElement.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.offsetHeight,
          document.body.clientHeight,
          document.documentElement.clientHeight
        ) -
        72 -
        64 -
        24
      );
    }
  },
  methods: {
    searchHistory(search) {
      if (search === "" || search === null) {
        return this.list;
      }
      return this.list.filter(historyItem => historyItem.changedId == search);
    }
  }
});
</script>

<style scoped>
.scroller {
  height: 100%;
}
</style>
